__turbopack_context__.v({
  "caption": "WorkIndex-module-scss-module__GlJk1q__caption",
  "captionYear": "WorkIndex-module-scss-module__GlJk1q__captionYear",
  "cell": "WorkIndex-module-scss-module__GlJk1q__cell",
  "cellMedia": "WorkIndex-module-scss-module__GlJk1q__cellMedia",
  "filters": "WorkIndex-module-scss-module__GlJk1q__filters",
  "index": "WorkIndex-module-scss-module__GlJk1q__index",
  "listWrap": "WorkIndex-module-scss-module__GlJk1q__listWrap",
  "mosaic": "WorkIndex-module-scss-module__GlJk1q__mosaic",
  "note": "WorkIndex-module-scss-module__GlJk1q__note",
  "noteShown": "WorkIndex-module-scss-module__GlJk1q__noteShown",
  "toolbar": "WorkIndex-module-scss-module__GlJk1q__toolbar",
  "work-results": "WorkIndex-module-scss-module__GlJk1q__work-results",
});
